<template>
  <highcharts :key="chartKey" :options="chartOptions" />
</template>

<script>
export default {
  name: 'LineChart',

  props: {
    chartKey: {
      type: Number,
      default: 0,
    },
    chartTitle: {
      type: String,
      default: '',
    },
    chartData: {
      type: Array,
      default: () => [],
    },
    chartSeriesName: {
      type: String,
      default: '',
    },
    chartConfig: {
      type: Object,
      required: true,
    },
    chartMarkerStyle: {
      type: Object,
      default: () => ({
        symbol: 'circle',
        lineWidth: 2,
        lineColor: '',
      }),
    },
    chartLanguageCallback: {
      type: Function,
    },
    chartFormatterCallback: {
      type: Function,
    },
  },

  computed: {
    chartOptions: {
      get() {
        const vueThis = this
        return {
          lang: vueThis.chartLanguageCallback(),
          chart: vueThis.chartConfig.chart,
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
            verticalAlign: 'top',
          },
          title: {
            align: 'center',
            verticalAlign: 'bottom',
            text: vueThis.chartTitle,
          },
          plotOptions: {
            series: vueThis.chartConfig.series,
          },
          tooltip: {
            formatter() {
              const data = [
                { val: this.series.name, format: '' },
                { val: this.point.x, format: 'date' },
                { val: this.point.y, format: 'percent' },
              ]
              return vueThis.chartFormatterCallback(data, '<br/>')
            },
          },
          xAxis: {
            title: null,
            type: vueThis.chartConfig.xAxis.type,
            labels: {
              style: vueThis.chartConfig.xAxis.style,
              rotation: vueThis.chartConfig.xAxis.rotation,
              formatter: (val) => vueThis.chartFormatterCallback([{ val: val.value, format: 'date' }], ''),
            },
          },
          yAxis: {
            title: null,
            min: vueThis.chartConfig.yAxis.min,
            max: vueThis.chartConfig.yAxis.max,
            tickInterval: vueThis.chartConfig.yAxis.tickInterval,
            labels: {
              formatter: (val) => vueThis.chartConfig.yAxis.formatter(val),
            },
          },
          series: [
            {
              data: vueThis.chartData,
              name: vueThis.chartSeriesName,
              marker: vueThis.chartConfig.marker,
            },
          ],
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
